export const automaticCheckJournalFields = {
    id: 'id',
    date: 'date',
    startDate: 'startDate',
    finishDate: 'finishDate',
    executedByName: 'executedByName',
    progressStatus: 'progressStatus',
    resultStatus: 'resultStatus',
    sendNotification: 'sendNotification',
} as const;
